import { apiClient } from './api'
import { resolveEventId } from './eventService'
import type { Session } from '../data/types'

/**
 * Personal agenda (saved sessions) client. Requires an attendee session cookie;
 * calls are event-scoped (resolved by slug via eventService). When the attendee
 * isn't signed in these will 401 — callers fall back to local-only storage.
 */
export const agendaService = {
  getSavedIds: async (): Promise<string[]> => {
    const id = await resolveEventId()
    return apiClient
      .get<{ sessionIds: string[] }>(`/events/${id}/agenda`)
      .then((r) => r.data.sessionIds)
  },

  getSavedSessions: async (): Promise<Session[]> => {
    const id = await resolveEventId()
    return apiClient
      .get<Session[]>(`/events/${id}/agenda/sessions`)
      .then((r) => r.data)
  },

  save: async (sessionId: string): Promise<void> => {
    const id = await resolveEventId()
    await apiClient.put(`/events/${id}/agenda/sessions/${sessionId}`)
  },

  unsave: async (sessionId: string): Promise<void> => {
    const id = await resolveEventId()
    await apiClient.delete(`/events/${id}/agenda/sessions/${sessionId}`)
  },

  /** Absolute URL to the .ics export (opened in a new tab for download). */
  icsUrl: async (): Promise<string> => {
    const id = await resolveEventId()
    return `${apiClient.defaults.baseURL ?? ''}/events/${id}/agenda.ics`
  },
}
